import n from "./td-longtail-vue-components236.js";
/* empty css                              */
import t from "./td-longtail-vue-components98.js";
var s = function() {
  var e = this, r = e._self._c, a = e._self._setupProxy;
  return r(a.BaseDialog, { ref: "baseDialog", class: ["flyout", e.customClass], attrs: { "heading-text": e.headingText, "aria-label": e.ariaLabel, "custom-container-class": {
    "base-dialog__container--success": e.success,
    "base-dialog__container--error": e.error,
    "base-dialog__container--warning": e.warning
  }, "close-on-backdrop": e.closeOnBackdrop, "disable-focus-trap": e.disableFocusTrap, "data-tealium-rel": e.dataTealiumRel, "close-autofocus": e.closeAutofocus }, on: { onCloseModal: () => e.$emit("onCloseModal") }, scopedSlots: e._u([{ key: "trigger", fn: function({ open: o }) {
    return [e._t("trigger", null, { open: o })];
  } }, { key: "header", fn: function({ close: o }) {
    return [e._t("header", null, { close: o })];
  } }, { key: "default", fn: function({ close: o }) {
    return [e._t("default", null, { close: o })];
  } }, { key: "footer", fn: function({ close: o }) {
    return [e._t("footer", null, { close: o })];
  } }], null, !0) });
}, l = [], c = /* @__PURE__ */ t(
  n,
  s,
  l,
  !1,
  null,
  "9bcb14e7"
);
const d = c.exports;
export {
  d as default
};
